import { combineReducers } from 'redux';
import commonReducer from './commonReducer';
import dashboardReducer from './dashboardReducer';
import instrumentListReducer from './instrumentListReducer';
import tradepanelReducer from './tradepanelReducer';
import changePasswordReducer from './changePasswordReducer';
import reportReducer from './reportReducer';
import chartReducer from './chartReducer';
import tradeBookReducer from './tradeBookReducer';
import activityReducer from './activityReducer';
import newsFeedReducer from './newsFeedReducer';

export default combineReducers({
  commonReducer,
  dashboardReducer,
  instrumentListReducer,
  tradepanelReducer,
  changePasswordReducer,
  reportReducer,
  chartReducer,
  tradeBookReducer,
  activityReducer,
  newsFeedReducer
});
